import { c as _c } from "react/compiler-runtime";
import { LinkButton, MarkdownText, Truncate } from '@onefootprint/ui';
import { cx } from 'class-variance-authority';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
type TruncatedTextProps = {
  text: string;
  truncatedTextNumLines: number;
  className?: string;
  supportMarkdown?: boolean;
};
const TruncatedText = t0 => {
  const $ = _c(20);
  const {
    text,
    truncatedTextNumLines,
    className,
    supportMarkdown
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "truncatedText"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const [isExpanded, setIsExpanded] = useState(false);
  const [showToggleButton, setShowToggleButton] = useState(false);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = truncated => {
      if (truncated) {
        setShowToggleButton(true);
      }
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleTruncate = t2;
  let t3;
  if ($[2] !== supportMarkdown || $[3] !== text) {
    t3 = supportMarkdown ? <MarkdownText>{text}</MarkdownText> : <bdi>{text}</bdi>;
    $[2] = supportMarkdown;
    $[3] = text;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const content = t3;
  let t4;
  if ($[5] !== isExpanded || $[6] !== showToggleButton || $[7] !== t) {
    t4 = showToggleButton ? <LinkButton variant="label-2" onClick={() => setIsExpanded(_temp)}>{isExpanded ? t(_temp2) : t(_temp3)}</LinkButton> : null;
    $[5] = isExpanded;
    $[6] = showToggleButton;
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const toggleButton = t4;
  const t5 = supportMarkdown && "flex flex-col items-start";
  let t6;
  if ($[9] !== className || $[10] !== t5) {
    t6 = cx(t5, className);
    $[9] = className;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== content || $[13] !== isExpanded || $[14] !== truncatedTextNumLines) {
    t7 = isExpanded ? content : <Truncate lines={truncatedTextNumLines} direction="vertical" onTruncate={handleTruncate}>{content}</Truncate>;
    $[12] = content;
    $[13] = isExpanded;
    $[14] = truncatedTextNumLines;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t6 || $[17] !== t7 || $[18] !== toggleButton) {
    t8 = <div className={t6}>{t7}{toggleButton}</div>;
    $[16] = t6;
    $[17] = t7;
    $[18] = toggleButton;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
};
export default TruncatedText;
function _temp(prev) {
  return !prev;
}
function _temp2($) {
  return $.seeLess;
}
function _temp3($_0) {
  return $_0.seeMore;
}